import { Dayjs } from "dayjs";
import { FeatureToggles } from "./reducer";
import { getStatusTabs } from "./selector";
import { DealerAccount } from "../../../../api/dealer/types";
import {
  Returns,
  ReturnsResponse,
  StatusCount,
} from "../../../../api/returns/returnsInterfaces";
import { FilterWithInfo } from "../allReturnsGrid/types";

export interface ReturnDetailsForList extends Returns {
  fetchedFromCache: boolean;
}

export interface AllReturnsList extends ReturnsResponse {
  returns: ReturnDetailsForList[];
}

export interface ListReturnsState {
  accountId: string;
  selectedAccounts: DealerAccount[];
  authState?: { isAuthenticated?: boolean; accessToken?: string };
  returns: ReturnDetailsForList[];
  statusCount: StatusCount;
  tabIndex: number;
  isLoading: boolean;
  language: string;
  error?: any;
  isReturnsLoaded: boolean;
  showCancelModal: boolean;
  returnAttributesToCancel: {
    returnId: string;
    returnTypeCode: string;
    returnStatusList: string[];
  };
  filters: FilterWithInfo;
  pageNumber: number;
  pageSize: number;
  isFilterApplied: boolean;
  showCreateReturns: boolean;
  dealerLocation: string;
  sortField: string;
  sortDir: string;
  featureToggles: FeatureToggles;
  isUserAuthorizedToCreateReturn: boolean;
  isUserAuthorizedToEditReturn: boolean;
  isUserAuthorizedForMultipleAccounts: boolean;
}

export const totalPageCount = (state: ListReturnsState) => {
  const statusCount = state.statusCount as {
    [key: string]: number;
  };
  const statusTabs = getStatusTabs(state);
  return Math.ceil(
    (statusCount[statusTabs[state.tabIndex]] ?? 0) / state.pageSize
  );
};

export const dayJSFormatterForAPI = (value: Dayjs): string =>
  value.format("YYYY-MM-DD");
